import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

// Timeline-specific ActionCable subscription controller
// Subscribes to DataUpdatesChannel and dispatches messages for:
// - timeline_entry (filtered by property_id)
// - audit_log (filtered by auditable_id/auditable_type)
// - key_log (filtered by property_id)
//
// Usage:
//   <div data-controller="timeline-subscription"
//        data-timeline-subscription-property-id-value="123"
//        @timeline-subscription:message.window="handleUpdate($event.detail)">
//
export default class extends Controller {
  static values = {
    propertyId: Number
  }

  connect() {
    this.subscription = consumer.subscriptions.create(
      { channel: "DataUpdatesChannel" },
      {
        received: (message) => this.handleMessage(message)
      }
    )
  }

  disconnect() {
    this.subscription?.unsubscribe()
  }

  handleMessage(message) {
    // Only dispatch messages relevant to the timeline
    const isTimelineEntry = message.type === 'timeline_entry' &&
                            message.data?.property_id == this.propertyIdValue

    const isAuditLog = message.type === 'audit_log' &&
                       message.data?.auditable_id == this.propertyIdValue &&
                       message.data?.auditable_type === 'Property'

    const isKeyLog = message.type === 'key_log' &&
                     message.data?.property_id == this.propertyIdValue

    if (isTimelineEntry || isAuditLog || isKeyLog) {
      // Dispatch event for Alpine to handle
      this.dispatch("message", { detail: message })
    }
  }
}
